<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { Link } from '@inertiajs/vue3'

import { pageTitle } from '@consumer/logic/v2/header'

import { trackEvent } from '@shared/tracking'

import type Theme from '@consumer/enums/Consumer/Theme'
import { useScreen } from '@consumer/helpers/screen'
import { faClose } from '@fortawesome/pro-regular-svg-icons'
import type GIconButton from '@consumer/components/GIconButton.vue'
import GiftlyLogo from './Header/GiftlyLogo.vue'

withDefaults(defineProps<{
  currentTheme?: Theme
}>(), {  })

const emit = defineEmits(['close'])

const closeButtonEl = ref<InstanceType<typeof GIconButton>>()

const __$temp_1 = (useScreen()),
  isDesktop = _toRef(__$temp_1, 'isDesktop');

provide('currentTheme', __props.currentTheme)

function onClickClose (event: Event) {
  trackEvent('click', closeButtonEl.value?.$el)
  emit('close')
}

defineExpose({
  closeButtonEl,
})
</script>

<template>
  <div
    class="w-full z-navbar bg-white flex items-center px-3
      lg:px-0 lg:max-w-screen-lg mx-auto"
    :style="{ height: isDesktop ? '92px' : '58px' }"
  >
    <div class="flex items-center gap-4">
      <GiftlyLogo/>

      <component
        :is="pageTitle?.href ? Link : 'div'"
        :href="pageTitle?.href"
        class="no-underline group"
      >
        <h1
          class="text-sm leading-none font-medium text-v2-tertiary"
          :class="pageTitle?.href && 'hover:text-navy'"
        >
          {{ pageTitle?.text }}
        </h1>
      </component>
    </div>

    <slot/>

    <div class="flex-grow"/>

    <GIconButton
      id="close-modal-button"
      ref="closeButtonEl"
      :icon="faClose"
      size="medium"
      label="Close Modal"
      data-testid="close-button"
      @click.prevent="onClickClose"
    />
  </div>
</template>
